<div class="dialog-header-container d-flex align-items-center justify-content-between p-3 border-bottom bg-white">
  <h2 mat-dialog-title class="m-0 fs-5 fw-bold text-dark">{{ inputData.title }}</h2>
  <button mat-icon-button mat-dialog-close (click)="resetForm()" aria-label="Fermer">
    <mat-icon class="text-muted">close</mat-icon>
  </button>
</div>

<mat-dialog-content [formGroup]="userForm" class="p-3 bg-white custom-dialog-content">
  
  <mat-horizontal-stepper [linear]="true" #stepper class="clean-stepper">
    
    <!-- Étape 1 : Infos personnelles -->
    <mat-step formGroupName="userPersoInfo" [stepControl]="userForm.get('userPersoInfo')!" label="Infos personnelles">
      <div class="d-flex flex-column gap-1 pt-3">
        
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Nom & Prénom</mat-label>
          <input matInput type="text" formControlName="name" placeholder="Entrez le nom de l'utilisateur">
          @if (userForm.get('userPersoInfo')?.get('name')?.hasError('required')) {<mat-error>obligatoire</mat-error>}
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Genre</mat-label>
          <mat-select formControlName="gender">
            <mat-option>Choisir un genre</mat-option>
            <mat-option value="masculin">Masculin</mat-option>
            <mat-option value="feminin">Féminin</mat-option>
          </mat-select>
          @if (userForm.get('userPersoInfo')?.get('gender')?.hasError('required')) {<mat-error>obligatoire</mat-error>}
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Adresse</mat-label>
          <input matInput type="text" formControlName="adresse" placeholder="Entrez le nom du propriétaire">
          @if (userForm.get('userPersoInfo')?.get('adresse')?.hasError('required')) {<mat-error>obligatoire</mat-error>}
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Email</mat-label>
          <input matInput type="text" formControlName="email" placeholder="Entrez un email">
          @if (userForm.get('userPersoInfo')?.get('email')?.hasError('email')) {<mat-error>email invalide</mat-error>}
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Téléphone</mat-label>
          <input matInput type="text" formControlName="tel" placeholder="Entrez un numéro de tel.">
          @if (userForm.get('userPersoInfo')?.get('tel')?.hasError('required')) {<mat-error>obligatoire</mat-error>}
        </mat-form-field>

        <mat-form-field appearance="outline" [ariaDisabled]="true" class="w-100 input-with-action">
          <mat-label>Profil</mat-label>
          <input matInput type="text" [disabled]="true" formControlName="profil_name" placeholder="Choisir un profil.">
          <button type="button" mat-icon-button color="primary" matSuffix (click)="selectProfil()" matTooltip="Sélectionner un profil">
            <mat-icon>list_alt</mat-icon>
          </button>
          @if (userForm.get('userPersoInfo')?.get('profil_id')?.hasError('required')) {<mat-error>obligatoire</mat-error>}
        </mat-form-field>

        <div class="d-flex justify-content-end pt-3">
          <button type="button" mat-flat-button color="primary" matStepperNext [disabled]="userForm.get('userPersoInfo')?.invalid || inputData.update" class="px-4">
            <span>Suivant</span>
          </button>
        </div>
        
      </div>
    </mat-step>

    <!-- Étape 2 : Infos du compte -->
    <mat-step formGroupName="userAccountInfo" [stepControl]="userForm.get('userAccountInfo')!" label="Infos du compte">
      <div class="d-flex flex-column gap-1 pt-3">
        
        @if (!inputData.update) {
          
          <mat-form-field appearance="outline" class="w-100 input-with-action">
            <mat-label>Nom d'utilisateur</mat-label>
            <input matInput type="text" formControlName="username" placeholder="Entrez un login">
            <button type="button" mat-icon-button color="primary" matSuffix (click)="generateUsername()" matTooltip="Générer automatiquement">
              <mat-icon>autorenew</mat-icon>
            </button>
            @if (userForm.get('userAccountInfo')?.get('username')?.hasError('required')) {<mat-error>obligatoire</mat-error>}
          </mat-form-field>

          <ng-container formGroupName="password">
            
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Mot de passe</mat-label>
              <input matInput type="password" formControlName="password" placeholder="Entrez un mot de passe">
              @if (userForm.get('userAccountInfo')?.get('password')?.get('password')?.hasError('required')) {<mat-error>obligatoire</mat-error>}
              @if (userForm.get('userAccountInfo')?.get('password')?.get('password')?.hasError('minlength')) {<mat-error>au moins 8 caractères</mat-error>}
            </mat-form-field>

            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Confirmer le mot de passe</mat-label>
              <input matInput type="password" formControlName="confirmPassword" placeholder="Confirmez le mot de passe">
              @if (userForm.get('userAccountInfo')?.get('password')?.get('confirmPassword')?.hasError('required')) {<mat-error>obligatoire</mat-error>}
              @if (userForm.get('userAccountInfo')?.get('password')?.get('confirmPassword')?.hasError('confirmPassword')) {<mat-error>les deux champs ne correspondent pas</mat-error>}
            </mat-form-field>

          </ng-container>
        }
        
        <div class="d-flex justify-content-start pt-3">
          <button type="button" mat-stroked-button color="primary" matStepperPrevious class="px-4">
            <span>Précédent</span>
          </button>
        </div>

      </div>
    </mat-step>

  </mat-horizontal-stepper>

</mat-dialog-content>

<mat-dialog-actions align="end" class="p-3 border-top bg-light m-0 gap-2">
  <button mat-stroked-button mat-dialog-close color="warn" class="px-4" (click)="resetForm()">Fermer</button>
  
  @if (inputData.update) {
    <button [disabled]="userForm.invalid" mat-flat-button color="primary" class="px-4" (click)="onUpdate()">Modifier</button>
  } @else {
    <button [disabled]="userForm.invalid" mat-flat-button color="primary" class="px-4" (click)="onAdd()">Enregistrer</button>
  }
</mat-dialog-actions>
